var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"upvote-button",class:_vm.upvoted && 'upvote-button--upvoted'},[_vm._v(" "+_vm._s(_vm.upvoted ? "Upvoted" : "Upvote")+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }